// Typelizer digest 5d9cfe57972972584b0fae15beb8be55
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /accountant/clients */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/clients', {}, options),
    method: 'get',
  }),

  /** GET /accountant/clients/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/clients/:id', params, options),
    method: 'get',
  }),
}
